import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";
import style from "./form.module.scss";
import { TODIS_SECONDARY_BTN, TODIS_TERTIARY_BTN } from "../../components/Buttons";
import { TODIS_SUCCESS_TOAST } from "../../components/Toasts";
import arrow from "../../assets/icons/arrow-white.svg";
import save from "../../assets/icons/save.svg";
import check from "../../assets/icons/check.svg";
import download from "../../assets/icons/download.svg";
import TODIS_FORM_LP from '../DataCollection/lp_form';
import TODIS_FORM_NP from '../DataCollection/np_form';
import TODIS_FORM_NRAILS from "../DataCollection/nrails_form";
import TODIS_FORM_IP from "../DataCollection/ip_form";
import TODIS_FORM_IRAILS from '../DataCollection/irails_form';
import TODIS_FORM_LRAILS from '../DataCollection/lrails_form';
import TODIS_FORM_NIWW from '../DataCollection/niww_form';
import TODIS_FORM_IIWW from '../DataCollection/iiww_form';
import TODIS_FORM_LIWW from '../DataCollection/liww_form';
import TODIS_FORM_NIWWPORTS from '../DataCollection/niwwports_form';
import TODIS_FORM_LIWWPORTS from '../DataCollection/liwwports_form';
import TODIS_FORM_IIWWPORTS from '../DataCollection/iiwwports_form';
import TODIS_FORM_NIRPORTS from '../DataCollection/nairports_form';
import TODIS_FORM_LIRPORTS from '../DataCollection/lairports_form';
import TODIS_FORM_IIRPORTS from '../DataCollection/iairports_form';
import TODIS_FORM_NSAEPORTS from '../DataCollection/nseaports_form';
import TODIS_FORM_LSAEPORTS from '../DataCollection/lseaports_form';
import TODIS_FORM_ISAEPORTS from '../DataCollection/iseaports_form';
import TODIS_FORM_NFREIGHTERMINAL from '../DataCollection/nfreighterminal_form';
import TODIS_FORM_LFREIGHTERMINAL from '../DataCollection/lfreighterminal_form';
import TODIS_FORM_IFREIGHTERMINAL from '../DataCollection/ifreighterminal_form';
import TODIS_FORM_ACQUISRAIL from '../DataCollection/acquis_form';
import TODIS_FORM_BORDERCROSSRAILS from '../DataCollection/nbordercrossrails_form';
import TODIS_FORM_BORDERCROSSROADS from '../DataCollection/nbordercrossroads_form';
import Swal from 'sweetalert2'
import { TODIS_NP_SCHEMA, NP_INIT } from "../../.config/form/network_performance";
import { TODIS_LP_SCHEMA, LP_INIT } from "../../.config/form/live_project_monitoring";
import { TODIS_IP_SCHEMA, IP_INIT } from "../../.config/form/implement_project_monitoring";
import { TODIS_NRAIL_SCHEMA, NRAIL_INIT } from "../../.config/form/rails_network_performance";
import { TODIS_IRAIL_SCHEMA, IRAIL_INIT } from "../../.config/form/rails_implement_project_monitoring";
import { TODIS_LRAIL_SCHEMA, LRAIL_INIT } from "../../.config/form/rails_live_project_monitoring";
import { TODIS_NSAEPORTS_SCHEMA, NSAEPORTS_INIT } from "../../.config/form/seaport_network_performance";
import { TODIS_LSAEPORTS_SCHEMA, LSAEPORTS_INIT } from "../../.config/form/seaport_live_project_monitoring";
import { TODIS_ISAEPORTS_SCHEMA, ISAEPORTS_INIT } from "../../.config/form/seaport_implement_project_monitoring";
import { TODIS_NAIRPORTS_SCHEMA, NAIRPORTS_INIT } from "../../.config/form/airport_network_performance";
import { TODIS_NIWWPORTS_SCHEMA, NIWWPORTS_INIT } from "../../.config/form/iwwports_network_performance";
import { TODIS_LIWWPORTS_SCHEMA, LIWWPORTS_INIT } from "../../.config/form/iwwports_live_project_monitoring";
import { TODIS_IIWWPORTS_SCHEMA, IIWWPORTS_INIT } from "../../.config/form/iwwports_implement_project_monitoring";
import { TODIS_NIWW_SCHEMA, NIWW_INIT } from "../../.config/form/iww_network_performance";
import { TODIS_LIWW_SCHEMA, LIWW_INIT } from "../../.config/form/iww_live_project_monitoring";
import { TODIS_IIWW_SCHEMA, IIWW_INIT } from "../../.config/form/iww_implement_project_monitoring";
import { TODIS_NFREIGHTERMINAL_SCHEMA, NFREIGHTERMINAL_INIT } from "../../.config/form/freighterminal_network_performance";
import { TODIS_LFREIGHTERMINAL_SCHEMA, LFREIGHTERMINAL_INIT } from "../../.config/form/freighterminal_live_project_monitoring";
import { TODIS_IFREIGHTERMINAL_SCHEMA, IFREIGHTERMINAL_INIT } from "../../.config/form/freighterminal_implement_project_monitoring";
import { TODIS_LAIRPORT_SCHEMA, LAIRPORT_INIT } from "../../.config/form/airport_live_project_monitoring";
import { TODIS_IAIRPORT_SCHEMA, IAIRPORT_INIT } from "../../.config/form/airport_implement_project_monitoring";

import { TODIS_RAILBORDERCROSS_SCHEMA, RAILBORDERCROSS_INIT } from "../../.config/form/bordercross_railways_network_performance";
import { TODIS_ROADBORDERCROSS_SCHEMA, ROADBORDERCROSS_INIT } from "../../.config/form/bordercross_roads_network_performance";

import { TODIS_ACQUIS_SCHEMA, ACQUIS_INIT } from "../../.config/form/acquis_network_performance";
import { TODIS_MODAL_DATACOLLECTION } from "../../components/Modals/ModalDatacollecction";
import { TODIS_MODAL_VALIDATE } from "../../components/Modals/ModalValidate";
import { Formik, Form } from 'formik';
import "react-datepicker/dist/react-datepicker.css";
import { DataCollectionService } from "../../HttpService/DataCollectionService";
import { useNavigate, useLocation } from "react-router-dom";
import { TODIS_MODAL_REJECT } from "../../components/Modals/ModalDicard";
import AuthContext from "../../auth/authContext";
import { TODIS_BTN_PRIMARY } from '../../components/Buttons';
import { BsPrinter } from "react-icons/bs";

const FORMS = {
    //Roads
    //"NETWORKPERFORMING" : [TODIS_FORM_NP, NP_INIT, TODIS_NP_SCHEMA, "Roads-npm","Roads Network Performance", 18],
     //Roads
     "ROADNPM" : [TODIS_FORM_NP, NP_INIT, TODIS_NP_SCHEMA, "Roads-npm","Roads Network Performance", 18],
     "ROADLIVE": [TODIS_FORM_LP, LP_INIT, TODIS_LP_SCHEMA, "Roads-live","Live Project Monitoring",17],
     "ROADIMP": [TODIS_FORM_IP, IP_INIT, TODIS_IP_SCHEMA, "Roads-imp","Implement Project Monitoring",16],
     //Reilwais
     "RAILWAYSNPM": [TODIS_FORM_NRAILS, NRAIL_INIT, TODIS_NRAIL_SCHEMA, "Railways-npm","Rails Network Performance",15],    
     "RAILWAYSLIVE": [TODIS_FORM_LRAILS, LRAIL_INIT, TODIS_LRAIL_SCHEMA, "Railways-live","Rails Live Project Monitoring",14],
     "RAILWAYSIMP": [TODIS_FORM_IRAILS, IRAIL_INIT, TODIS_IRAIL_SCHEMA, "Railways-imp","Rails Implement Project Monitoring",13],
     //Seaport
     "SEAPORTSNPM": [TODIS_FORM_NSAEPORTS, NSAEPORTS_INIT, TODIS_NSAEPORTS_SCHEMA, "Seaports-npm","Seaports Network Performance",21],
     "SEAPORTSLIVE": [TODIS_FORM_LSAEPORTS, LSAEPORTS_INIT, TODIS_LSAEPORTS_SCHEMA, "Seaports-live","Seaports Live Project Mornitoring",20],
     "SEAPORTSIMP": [TODIS_FORM_ISAEPORTS, ISAEPORTS_INIT, TODIS_ISAEPORTS_SCHEMA, "Seaports-imp","Seaports Implemented Project Mornitoring",19],
     //Airport
     "AIRPORTSNPM": [TODIS_FORM_NIRPORTS, NAIRPORTS_INIT, TODIS_NAIRPORTS_SCHEMA,"Airports-npm", "Airports Network Performance",3],
     "AIRPORTSLIVE": [TODIS_FORM_LIRPORTS, LAIRPORT_INIT, TODIS_LAIRPORT_SCHEMA, "Airports-live","Airports Live Project Mornitoring",2],
     "AIRPORTSIMP": [TODIS_FORM_IIRPORTS, IAIRPORT_INIT, TODIS_IAIRPORT_SCHEMA, "Airports-imp","Airports Implemented Project Mornitoring",1],
     //iwwport
     "IWWPORTSNPM": [TODIS_FORM_NIWWPORTS, NIWWPORTS_INIT, TODIS_NIWWPORTS_SCHEMA,"IwwPorts-npm", "Inland Waterways Ports Network Performance",12],
     "IWWPORTSLIVE": [TODIS_FORM_LIWWPORTS, LIWWPORTS_INIT, TODIS_LIWWPORTS_SCHEMA,"IwwPorts-live", "Inland Waterways Ports Live Project Mornitoring",11],
     "IWWPORTSIMP": [TODIS_FORM_IIWWPORTS, IIWWPORTS_INIT, TODIS_IIWWPORTS_SCHEMA,"IwwPorts-imp", "Inland Waterways Ports Implemented Project Mornitoring",10],
     //niww
     "IWWNPM": [TODIS_FORM_NIWW, NIWW_INIT, TODIS_NIWW_SCHEMA,"Iww-npm", "Inland Waterways - Network Performance",9],
     "IWWLIVE": [TODIS_FORM_LIWW, LIWW_INIT, TODIS_LIWW_SCHEMA,"Iww-live", "Inland Waterways Live Project Mornitoring",8],
     "IWWIMP": [TODIS_FORM_IIWW, IIWW_INIT, TODIS_IIWW_SCHEMA,"Iww-imp", "Inland Waterways Implemented Project Mornitoring",7],
     //freigterminal
     "FREIGHTNPM": [TODIS_FORM_NFREIGHTERMINAL, NFREIGHTERMINAL_INIT, TODIS_NFREIGHTERMINAL_SCHEMA,"Freight-npm","Freight Terminal Network Performance",6],
     "FREIGHTLIVE": [TODIS_FORM_LFREIGHTERMINAL, LFREIGHTERMINAL_INIT, TODIS_LFREIGHTERMINAL_SCHEMA,"Freight-live", "Freight Terminal Live Project Mornitoring ",5],
     "FREIGHTIMP": [TODIS_FORM_IFREIGHTERMINAL, IFREIGHTERMINAL_INIT, TODIS_IFREIGHTERMINAL_SCHEMA,"Freight-imp", "Freight Terminal Implemented Project Mornitoring",4],
     //border cross
     "RAILWAYSBORDERNPM": [TODIS_FORM_BORDERCROSSRAILS, RAILBORDERCROSS_INIT, TODIS_RAILBORDERCROSS_SCHEMA,"Railways-BorderCrossing-npm","Railways Border crossing Network Performance",22],
     "ROADSSBORDERNPM": [TODIS_FORM_BORDERCROSSROADS, ROADBORDERCROSS_INIT, TODIS_ROADBORDERCROSS_SCHEMA,"Road-BorderCrossing-npm","Road Border crossing Network Performance",24],
     //EUACQUIS
     "EUACQUIS": [TODIS_FORM_ACQUISRAIL, ACQUIS_INIT, TODIS_ACQUIS_SCHEMA,"EU-acquis","EU Acquis Compliance Matrix"],
}

const TODIS_FORM = ({type, request,expanding,fullMap, flagForm}) => {
    //console.log(type);
    let FormComponent = type==null ? null: FORMS[type][0];

    const {user} = useContext(AuthContext);

    const [dataform, setDataForm] = useState(type==null ? null: FORMS[type][1]);
    const [status, setStatus] = useState(true)
    const [cError, setCError] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [showvalidate, setShowValidate] = useState(false);
    const [showSubmitToast, setShowSubmitToast] = useState(false);
    //const {state} = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            let queryType = FORMS[type][5];
            //if (request != null) {
            //    //const res = await new DataCollectionService("data/load/" + requestId).getFormById(); 
            //    //const res = await new DataCollectionService("data/load/30").getFormById(); 
            //    setDataForm(request)
            //}   
            if (request != null) {
                //const res = await new DataCollectionService("data/load/" + requestId).getFormById();
                const res = await new DataCollectionService("data/load/"+request+"/"+queryType).getFormById();
                //console.log(res);
                setDataForm(res)
            }           
        })();
    }, [request])

    const leerdatos = (data) => {     
        setDataForm(data);
    };

    const getFirstErrorKey = (object, keys = []) => {
        const firstErrorKey = Object.keys(object)[0];
        if (typeof (object[firstErrorKey]) === "object") {
            return getFirstErrorKey(object[firstErrorKey], [...keys, firstErrorKey]);
        }
        return [...keys, firstErrorKey].join(".");
    };

    const search = (e) => {        
        const grafic = new BroadcastChannel("printPDF");        
        var params = {
           data: dataform,
           type: type
        }
        grafic.postMessage(params);
    }

    //console.log("FLAGFORM: ", flagForm)

    return (
        <Container fluid className={`${style.todisFormWrapper} ${"p-4"}`} style={{height:'calc(100vh - 120px)'}}>
                <Formik
                    initialValues={dataform}
                    enableReinitialize={true}
                    validate={() => { }}
                    validationSchema={status ? false : FORMS[type][2]}
                    onSubmit={async (values, errors) => {
                        //console.log(values);
                        //let url = 'data/submit/' + state.requestId + '/' + state.id + '/' + FORMS[type][3] + '/john.smith';
                        //const res = await new DataCollectionService(url).createform(values);
                        //if(res.status == 200){
                        //    setShowSubmitToast(true)
                        //    setTimeout(async () => {
                        //        navigate("/WorkFlow/")
                        //    }, 1000)
                        //}
                    }}>
                    {({ errors, touched, values, validateForm, handleChange, dirty, isValid, isSubmitting, handleSubmit, setFieldValue, setFieldTouched, setFieldError, resetForm, flagForm }) => (   //pasar aqui el flagForm
                         <>
                         <Row className="todis-form-action-panel pb-3">
                            <Col lg={4}>
                                <Stack gap={0}>
                                    <h5 className="todis-header">{FORMS[type][4]} </h5>  
                                </Stack>
                            </Col>
                            <Col lg={4}>
                                <Stack gap={0}>
                                    <TODIS_BTN_PRIMARY onclick={search} variant="primary" classes="fw-bolder" icon={BsPrinter} title="Print summary PDF"/>
                                </Stack>
                            </Col>                            
                         </Row>

                        <Form className={style.todisFormContent} onSubmit={handleSubmit} method="post">
                            <FormComponent errors={errors} touched={touched} status={status} setFieldValue={setFieldValue} values={values} flagForm = {flagForm}/>  {/* meter aqui el flagForm */} 
                            {/* {
                                !status &&
                                <div className="todis-action-form">
                                    <Button variant="outline-primary" onClick={() => validDiscard(resetForm)} className="todis-reset-btn">DISCARD </Button>
                                    <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{margin: "0.5rem"}}  type="submit">SUBMIT <img src={arrow} width="15" className="todis-icon-btn" alt="submit" /></Button>
                                </div>
                            } */}
                        </Form>
                        </>
                    )}
                </Formik>
            </Container >
    )
}

export default TODIS_FORM;